import { BackButtonTopNavigation, BaseTopNavigation, IconButton, semanticColor } from '@repo/ui';
import { ReactNode, Suspense } from 'react';

export const SignDefaultLayout = ({ children }: { children: ReactNode }) => {
  return (
    <Suspense>
      <main className={`flex flex-col items-center justify-center flex-1`}>
        <div className={`container !container-medium container-padding-medium flex flex-col justify-center`}>{children}</div>
      </main>
    </Suspense>
  );
};

export const SignBackButtonLayout = ({ children }: { children: ReactNode }) => {
  return (
    <Suspense>
      <header>
        <BackButtonTopNavigation bg bgColor={semanticColor.neutral.background.main} />
      </header>
      <main className={`flex flex-col items-center flex-1`}>
        <div className={`container !container-medium container-padding-medium flex flex-1 flex-col h-full`}>{children}</div>
      </main>
      <footer id={'bznav-footer'} className={'sticky bottom-0'} />
    </Suspense>
  );
};

export const SignCloseButtonLayout = ({ children, closeAction }: { children: ReactNode; closeAction: () => void }) => {
  return (
    <Suspense>
      <header>
        <BaseTopNavigation leftAction={<IconButton iconType={'close'} onClick={closeAction} />} bg bgColor={semanticColor.neutral.background.main} />
      </header>
      <main className={`flex flex-col items-center flex-1`}>
        <div className={`container !container-medium container-padding-medium flex flex-1 flex-col h-full`}>{children}</div>
      </main>
      <footer id={'bznav-footer'} className={'sticky bottom-0'} />
    </Suspense>
  );
};

export const SignNoHeaderLayout = ({ children }: { children: ReactNode }) => {
  return (
    <Suspense>
      <main className={`flex flex-col items-center flex-1 pt-top-navigation`}>
        <div className={`container !container-medium container-padding-large flex flex-1 flex-col h-full py-spacious-medium`}>{children}</div>
      </main>
      <footer id={'bznav-footer'} className={'sticky bottom-0'} />
    </Suspense>
  );
};
